export const AUTHORIZATION_ROLE = {
  BACKOFFICE_ACCESS: 'BACKOFFICE_ACCESS',
  PARAMETERIZATION_ACCESS: 'PARAMETERIZATION_ACCESS',
  DOCUMENT_ANALYSIS_LAB_ACCESS: 'DOCUMENT_ANALYSIS_LAB_ACCESS'
} as const;

export type AuthorizationRole = typeof AUTHORIZATION_ROLE[keyof typeof AUTHORIZATION_ROLE];
